<template>
  <div>
    <AppHeader @refreshPage="init" />
    <div class="container">
      <div class="mint-box type2">
        <div class="title">
          <span>{{ $t('mintpage.text1') }}</span>
        </div>
        <avatar ref="avatar"></avatar>
        <div class="des">
          {{ $t('mintpage.text8') }}
        </div>
        <div class="select-btn btns">
          <el-button type="default" class="round up" @click="handleBack()">{{
            $t('back')
          }}</el-button>
          <el-button
            class="el-button--special round up"
            @click="handleMint"
            style="color: #ffffff"
            >{{ $t('mint') }}</el-button
          >
        </div>
      </div>
    </div>
    <mt-popup
      v-model="popupVisible"
      position="bottom"
      :closeOnClickModal="false">
      <div class="pop-box" v-if="popType === 'success'">
        <div class="pop-title">{{ $t('mintnft') }}</div>
        <div class="result-box">
          <div class="h icons success">{{ $t('successed') }}</div>
          <div class="des">{{ $t('activitypage.text13') }}</div>
        </div>
        <el-button
          class="el-button--white block"
          style="margin-top: 1.7rem"
          @click="handleRoute"
          >{{ $t('ok') }}</el-button
        >
      </div>
      <div
        class="pop-close"
        @click="
          () => {
            this.popupVisible = false
          }
        "></div>
    </mt-popup>
  </div>
</template>
<script>
import { postBabeNftMynft } from '@/api/babe'

import Avatar from '../../components/Avatar.vue'

export default {
  name: 'BabeMintConfirm',
  components: {
    Avatar
  },
  data() {
    return {
      popupVisible: false,
      popType: null,
      rec_code: null
    }
  },
  watch: {
    popupVisible: {
      handler(n) {
        this.$stopScroll(n)
      },
      deep: true
    },
    '$i18n.locale'() {
      this.init()
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    init() {
      let params = JSON.parse(localStorage.getItem('mintinfo'))
      this.$refs.avatar.initData(params.imgData, params.selectIndexs)
    },
    handleMint() {
      postBabeNftMynft().then((res) => {
        if (res.data && res.data.length > 0) {
          this.$toast({
            message: this.$t('add.text95')
          })
        } else {
          this.$refs.avatar.mintImg((_) => {
            this.popType = 'success'
            this.popupVisible = true
            this.newNFTUrl = _.path
            this.rec_code = _.rec_code
            this.$store.dispatch('setRefresh', {
              name: 'BabeAccount',
              type: true
            })
          })
        }
      })
    },
    handleBack() {
      this.$router.push({
        name: 'BabeMint',
        params: {
          selectIndexs: this.$refs.avatar.selectIndexs,
          imgData: this.$refs.avatar.imgs
        }
      })
    },
    handleRoute() {
      this.$router.push({
        path: '/babe/mintsuccess',
        query: { rec_code: this.rec_code }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.btns {
  .el-button {
    width: 1.58rem;
    height: 0.48rem;
    line-height: 0.48rem;
    font-size: 0.14rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/babe/mintconfirm.vue